import React, { useEffect, useRef, useState } from "react";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import { useForm } from "react-hook-form";
import InputField from "../../../common/components/FormFields/InputField";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import {
  CameraIcon,
  DisabledUploadDocumentIcon,
  UploadButtonIcon,
} from "../assets/VisitorMAssets";
import CommonDivider from "../../../common/components/divider/CommonDivider";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import Webcam from "react-webcam";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import { vehicleTypeDropdown } from "../masters/services/VehicleTypeService";
import {
  departmentDropdown,
  fetchAdmissionList,
  fetchPatchDataNew,
  getdocumentTypeDropdown,
  getEmployeeBysearchString,
  getLocationDropdown,
  getPatientBysearchString,
  getPreviousVisitoryBysearchString,
  prefixDropdown,
  saveVisitor,
} from "../../services/VisitorRegistrationService";
import { UseCheckConsecutiveCharacters } from "../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";
import { VisitorCompanyBySearchString } from "../masters/services/VisitorCompanyService";
import { passTypeDropdown } from "../masters/services/PassTypeService";
import { CapitalizeStatement } from "../../../common/components/Custom Hooks/CapitalizeStatement";
import { format } from "date-fns";
import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import { RemoveIcon } from "../../../assets/CommonAssets";

const defaultValues = {
  searchByvisitorName: null,
  prefix: null,
  firstName: "",
  lastName: "",
  passType: null,
  visitorCompany: null,
  contactNo: "",
  documentType: null,
  perposeofVisit: "",
  whomtoMeet: null,
  visiteeEmail: "",
  visiteeMobileNo: "",
  department: null,
  location: null,
  multiVisit: false,
  fromdate: new Date(),
  toDate: new Date(),
  patientNameOrUhid: null,
  aboutCarriedLuggage: "",
  vehicleType: null,
  vehicleMake: "",
  vehicleDetails: "",
};

function VisitorRegistration() {
  const schema = yup.object().shape({
    prefix: yup.object().nullable().required("required"),
    passType: yup.object().required("Pass type is required"),
    // visitorCompany: yup.object().when('passType', {
    //     is: (value) => {
    //         return ['vendor', 'contractor']?.includes(value?.label?.toLowerCase());
    //     },
    //     then: (schema) =>
    //         schema
    //             .required('Company name is required')
    //             .shape({
    //                 label: yup.string().required('Company name is required'),
    //                 value: yup.string().required('Company value is required'),
    //             }),
    //     otherwise: (schema) => schema.nullable(),
    // }),
    // documentType: yup.object().required('Document type is required'),
    // whomtoMeet: yup.object().required('Whom to meet is required'),
    whomtoMeet: yup.object().when("passType", {
      is: (value) => {
        return !["patient visitor"]?.includes(value?.label?.toLowerCase());
      },
      then: (schema) =>
        schema.required("patientNameOrUhid name is required").shape({
          label: yup.string().required("Company name is required"),
          value: yup.string().required("Company value is required"),
        }),
      otherwise: (schema) => schema.nullable(),
    }),
    // department: yup.object().required('Department is required'),
    // location: yup.object().required('Location is required'),
    // vehicleType: yup.object().nullable().required("vehicle type is required"),

    // Input fields (originally empty string)
    firstName: yup.string().trim().required("First name is required"),
    lastName: yup.string().trim().required("Last name is required"),
    contactNo: yup
      .string()
      // .transform((value, originalValue) => (originalValue === '' ? undefined : value))
      .matches(/^[0-9]+$/, "Contact number must be digits only")
      .min(10, "Contact number must be at least 10 digits")
      .max(10, "contact number  not grater than 10")
      .required("contactNo is required"),
    // visiteeMobileNo: yup.string().required('Visitee mobile number is required').matches(/^\+?[1-9]\d{1,14}$/, 'Invalid phone number'),
    visiteeMobileNo: yup
      .string()
      .transform((value, originalValue) =>
        originalValue === "" ? undefined : value
      )
      .matches(/^[0-9]+$/, "Contact number must be digits only")
      .min(10, "Contact number must be at least 10 digits")
      .max(14, "contact number  not grater than 14")
      .nullable(),
    aboutCarriedLuggage: yup.string().max(500, "Too long"),
    vehicleMake: yup.string(),
    // perposeofVisit: yup.string().required('Purpose of visit is required').min(5, 'Too short'),
    // visiteeEmail: yup.string().required('Visitee email is required').email('Invalid email'),
    vehicleDetails: yup.string(),

    fromdate: yup.date().when("multiVisit", {
      is: true,
      then: () =>
        yup.date().required("From date is required").typeError("Invalid date"),
      otherwise: () => yup.date().nullable(),
    }),
    toDate: yup.date().when("multiVisit", {
      is: true,
      then: () =>
        yup
          .date()
          .required("To date is required")
          .typeError("Invalid date")
          .min(yup.ref("fromdate"), "To date cannot be before from date"),
      otherwise: () => yup.date().nullable(),
    }),
    patientNameOrUhid: yup.object().when("passType", {
      is: (value) => {
        return ["patient visitor"]?.includes(value?.label?.toLowerCase());
      },
      then: (schema) =>
        schema.required("patientNameOrUhid name is required").shape({
          label: yup.string().required("Company name is required"),
          value: yup.string().required("Company value is required"),
        }),
      otherwise: (schema) => schema.nullable(),
    }),
  });
  const {
    control,
    setValue,
    handleSubmit,
    reset,
    register,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });

  const [uploadDocuments, setUploadDocuments] = useState([]);
  const fileUploadRef = useRef(null);
  const webcamRef = useRef(null);
  const [postConfirmationModal, setPostConfirmationModal] = useState(false);
  const [isBackDrop, setIsBackdrop] = useState(false);
  const [finalObject, setFinalObject] = useState(null);
  const [image, setImage] = useState(null);
  const [showCamera, setShowCamera] = useState(false);
  const [isCameraloaded, setIsCameraLoaded] = useState(false);
  const [previousVisitorOptions, setPreviousVisitorOptions] = useState([]);
  const [prefixOptions, setPrefixOptons] = useState([]);
  const [visitorCompanyOptions, setVisitorCompanyOptions] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [patientOptions, setPatientOptions] = useState([]);
  const [vehicleTypeOptions, setVehicleTypeOptions] = useState([]);
  const [passTypeOptions, setPassTypeOptions] = useState([]);
  const [patientData, setPatientData] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { selectedRow } = location?.state || {};
  console.log("patientData", errors, patientData);

  //local variable
  const isMultiVisit = watch("multiVisit");
  const passType = watch("passType");
  const searchVisit = watch("searchByvisitorName");
  const patientNameOrUhid = watch("patientNameOrUhid");
  const loggedUser = JSON.parse(localStorage.getItem("userInfo"));
  console.log("passTypepassType", passType, patientNameOrUhid);
  console.log("loggedUser", loggedUser);

  // Camera settings
  const videoConstraints = {
    width: { ideal: 1080 },
    height: { ideal: 1080 },
    facingMode: "user", // Use "user" for front camera, "environment" for back camera
    aspectRatio: 1,
    frameRate: { ideal: 30, max: 60 },
  };

  // Capture Image from Webcam
  const capture = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      const base64Data = imageSrc?.split(",")[1];

      const imgObj = {
        profileImgName: `captured-image-${Date.now()}.png`,
        base64: base64Data,
        showImage: imageSrc,
      };
      setImage(imgObj);
      setShowCamera(false);
    }
  };
  console.log("errors", errors);

  // Remove Image and Show Camera Icon
  const removeImage = () => {
    setImage(null);
    setShowCamera(false);
    setIsCameraLoaded(false);
  };

  // const handleImageUpload = (e) => {
  //     const files = e?.target?.files;
  //     if (!files || files.length === 0) return;

  //     // Restrict to only 2 files
  //     if (files?.length + uploadDocuments?.length > 2) {
  //         warningAlert("You can only upload up to 2 images.");
  //         e.target.value = ""; // Reset file input
  //         return;
  //     }

  //     console.log("Selected files:", files);
  //     const validFormats = ["image/jpg", "image/jpeg", "image/png"];
  //     let newImages = [];
  //     let processedCount = 0;
  //     Array.from(files).forEach((file) => {
  //         if (validFormats.includes(file.type)) {
  //             const reader = new FileReader();
  //             reader.onloadend = (event) => {
  //                 const imgObj = {
  //                     profileImgName: file.name,
  //                     base64: event.target.result.split(",")[1],
  //                     showImage: event.target.result,
  //                 };
  //                 newImages.push(imgObj);
  //                 processedCount++;
  //                 // Update state only after all files are processed
  //                 if (processedCount === files.length) {
  //                     setUploadDocuments((prev) => [...prev, ...newImages]);
  //                     console.log("Updated uploadDocuments:", newImages);
  //                 }
  //             };
  //             reader.readAsDataURL(file);
  //         }
  //     });
  // };

  const handleSaveClick = (data) => {
    // if (uploadDocuments?.length === 0) {
    //     errorAlert("No documents uploaded. Please upload at least one document.");
    //     return;
    // }

    console.log("data", data);

    let postObj = {
      visitor: { id: data?.searchByvisitorName?.id ?? null },
      prefix: data?.prefix?.id ?? null,
      firstName: CapitalizeStatement(data?.firstName),
      lastName: CapitalizeStatement(data?.lastName),
      passType: { id: data?.passType?.id ?? null },
      visitorCompany: {
        id: ["vendor", "contractor"]?.some((type) =>
          data?.passType?.label?.toLowerCase()?.includes(type)
        )
          ? data?.visitorCompany?.id
          : null,
      },
      contactNo: Number(data?.contactNo),
      documentsType: data?.documentType?.id ?? null,
      whomToMeetEmployee:
        data?.whomtoMeet?.source?.toLowerCase() !== "doctor"
          ? data?.whomtoMeet?.id
          : null,
      whomToMeetDoctor:
        data?.whomtoMeet?.source?.toLowerCase() === "doctor"
          ? data?.whomtoMeet?.id
          : null,
      visitedMobileNo: Number(data?.visiteeMobileNo),
      department: data?.department?.id ?? null,
      location: data?.location?.id ?? null,
      isMultiVisit: data?.multiVisit,
      fromDate: data?.multiVisit
        ? format(new Date(data.fromdate), "yyyy-MM-dd")
        : format(new Date(), "yyyy-MM-dd"),
      toDate: data?.multiVisit
        ? format(new Date(data.toDate), "yyyy-MM-dd")
        : format(new Date(), "yyyy-MM-dd"),
      patientVisit: data?.passType?.label
        .toLowerCase()
        ?.includes("patient visitor")
        ? data?.patientNameOrUhid?.id
        : null,
      aboutLuggageCarried: CapitalizeStatement(data?.aboutCarriedLuggage),
      vehicleType: { id: data?.vehicleType?.id ?? null },
      vehicleMake: CapitalizeStatement(data?.vehicleMake),
      vehicleDetails: CapitalizeStatement(data?.vehicleDetails),
      uploadWebcam: image?.base64,
    };
    console.log("postObjpostObj", postObj);

    setFinalObject(postObj);
    setPostConfirmationModal(true);
  };

  const onSubmit = () => {
    setIsBackdrop(true);
    saveVisitor(finalObject)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200 || res.statusCode === 201) {
          setIsBackdrop(false);
          successAlert(res?.message);
          setPostConfirmationModal(false);
          navigate("/visitorManagement/visitorList");
          reset(defaultValues);
          setFinalObject(null);
          setImage(null);
        } else {
          errorAlert(res?.message);
          setIsBackdrop(false);
        }
      })
      .catch((error) => {
        errorAlert(error?.message);
        setIsBackdrop(false);
      });
  };

  useEffect(() => {
    // prefix Dropdown
    prefixDropdown()
      .then((response) => response?.data)
      .then((res) => {
        if (res.result?.length > 0) {
          setPrefixOptons(res?.result);
        }
      })
      .catch((error) => {
        setPrefixOptons([]);
      });

    //pass type Options
    passTypeDropdown()
      .then((response) => response?.data)
      .then((res) => {
        if (res.result?.length > 0) {
          setPassTypeOptions(res?.result);
        }
      })
      .catch((error) => {
        setPassTypeOptions([]);
      });

    // document Type Dropdown
    getdocumentTypeDropdown()
      .then((response) => response?.data)
      .then((res) => {
        if (res.result?.length > 0) {
          setDocumentTypeOptions(res?.result);
        }
      })
      .catch((error) => {
        setDocumentTypeOptions([]);
      });

    //location dropdown
    getLocationDropdown()
      .then((response) => response?.data)
      .then((res) => {
        if (res.result?.length > 0) {
          setLocationOptions(res?.result);
        }
      })
      .catch((error) => {
        setLocationOptions([]);
      });

    //vehicle Type Options
    vehicleTypeDropdown()
      .then((response) => response?.data)
      .then((res) => {
        if (res.result?.length > 0) {
          setVehicleTypeOptions(res?.result);
        }
      })
      .catch((error) => {
        setVehicleTypeOptions([]);
      });
  }, []);

  useEffect(() => {
    if (searchVisit !== null) {
      setValue("prefix", {
        id: searchVisit.prefixid,
        label: searchVisit?.prefix,
        value: searchVisit?.prefixid,
      });
      setValue("firstName", searchVisit?.firstName);
      setValue("lastName", searchVisit?.lastName);
      setValue("contactNo", searchVisit?.contactNo);
    } else {
      setValue("prefix", null);
      setValue("firstName", "");
      setValue("lastName", "");
      setValue("contactNo", "");
    }
  }, [searchVisit]);

  useEffect(() => {
    if (patientNameOrUhid !== null) {
      let listObj = {
        currentAdmission: 1,
        unitId: loggedUser?.unitId,
        floorId: null,
        menuId: null,
        searchString: "",
        searchId: patientNameOrUhid?.id,
        toDate: null,
        fromDate: null,
        size: 100,
        page: 0,
        isCancelled: false,
        isTentativeDischarge: false,
        otherThanIndia: 0,
        isPendingDocument: 0,
        pendingPassport: 0,
        presentOnBed: 1,
      };

      fetchAdmissionList(listObj)
        .then((response) => response?.data)
        .then((res) => {
          if (res?.statusCode === 200) {
            setPatientData(res?.result?.list);
          } else {
            setPatientData(null);
          }
        })
        .catch((err) => {
          setPatientData(null);
        });
    } else {
      setPatientData(null);
    }
  }, [patientNameOrUhid]);
  return (
    <div className="px-2 mt-12">
      {/* {CommonHeading("Visitor Registration")} */}
      <div>
        <h1 className="text-center mt-4 text-black font-bold text-xl font-Poppins ">
          Visitor Registration
        </h1>
      </div>
      <form onSubmit={handleSubmit(handleSaveClick)}>
        <div className="grid md:grid-cols-2 gap-x-2 mt-2         ">
          <div className="1st  border rounded-md p-2 border-[#0000006B] shadow ">
            <h1 className="text-[16px] text-[#000000]  font-bold mb-2">
              Visitor Registration
            </h1>
            <div className=" lg:flex justify-between w-full mb-2">
              <div className=" w-full lg:w-1/2 mb-2 lg:my-0">
                <SearchDropdown
                  control={control}
                  name="searchByvisitorName"
                  placeholder={"Search By Visitor Name/phoneNo"}
                  handleInputChange={(e) => {
                    if (e !== "" && UseCheckConsecutiveCharacters(e)) {
                      getPreviousVisitoryBysearchString(e)
                        .then((response) => response.data)
                        .then((res) => {
                          setPreviousVisitorOptions(res.result);
                        })
                        .catch((error) => {
                          console.log(error);
                          setPreviousVisitorOptions([]);
                        });
                    } else {
                      setPreviousVisitorOptions([]);
                    }
                  }}
                  dataArray={previousVisitorOptions}
                  searchIcon={true}
                  isClearable={true}
                />
              </div>
              <div>
                <CommonButton
                  label={"Visitors List"}
                  type={"button"}
                  className={"bg-[#073763] text-white "}
                  onClick={() => {
                    navigate("/visitorManagement/visitorList");
                  }}
                />
              </div>
            </div>
            <div className="grid  lg:grid-cols-2  gap-2">
              <div className=" grid  lg:grid-cols-2 gap-2 items-center ">
                <DropdownField
                  control={control}
                  placeholder="Prefix*"
                  name="prefix"
                  isSearchable={true}
                  isClearable={true}
                  error={errors?.prefix}
                  dataArray={prefixOptions}
                />
                <InputField
                  control={control}
                  label="First Name*"
                  name="firstName"
                  error={errors?.firstName}
                />
              </div>
              <InputField
                control={control}
                label="Last Name*"
                name="lastName"
                error={errors?.lastName}
              />
              <DropdownField
                control={control}
                placeholder="Pass Type*"
                name="passType"
                isSearchable={true}
                isClearable={true}
                error={errors?.passType}
                dataArray={passTypeOptions}
              />

              {(passType?.label?.toLowerCase() === "vendor" ||
                passType?.label?.toLowerCase() === "contractor") && (
                <div className="w-full">
                  <SearchDropdown
                    control={control}
                    name="visitorCompany"
                    placeholder={"Visitor Company"}
                    handleInputChange={(e) => {
                      if (e !== "" && UseCheckConsecutiveCharacters(e)) {
                        VisitorCompanyBySearchString(e)
                          .then((response) => response.data)
                          .then((res) => {
                            setVisitorCompanyOptions(res.result);
                          })
                          .catch((error) => {
                            console.log(error);
                          });
                      } else {
                        setVisitorCompanyOptions([]);
                      }
                    }}
                    dataArray={visitorCompanyOptions}
                    searchIcon={true}
                    isClearable={true}
                    error={errors.visitorCompany}
                  />
                </div>
              )}
              <InputField
                control={control}
                label="Contact No*"
                name="contactNo"
                type={"number"}
                error={errors?.contactNo}
              />
              <div className="flex items-center gap-2  ">
                <DropdownField
                  control={control}
                  placeholder="Document Type"
                  name="documentType"
                  isSearchable={true}
                  isClearable={true}
                  error={errors?.documentType}
                  dataArray={documentTypeOptions}
                />
                {/* {uploadDocuments?.length >= 2 ?
                                    <div className='cursor-default'>
                                        <DisabledUploadDocumentIcon type={"button"} />
                                    </div>
                                    :
                                    < button
                                        type='button'
                                        key={uploadDocuments}
                                        className="flex items-center gap-x-2 cursor-pointer">
                                        <input
                                            ref={fileUploadRef}
                                            type="file"
                                            multiple
                                            accept="image/jpg, image/jpeg, image/png"
                                            onChange={(e) => handleImageUpload(e)}
                                            style={{ display: "none" }}
                                            id="file-input"
                                        />

                                        <div
                                            className="flex gap-x-1 items-center cursor-pointer"
                                            onClick={() => fileUploadRef.current.click()}
                                        >
                                            <UploadButtonIcon type="button" />
                                        </div>
                                    </button>
                                } */}
              </div>
            </div>
            {/* <div className='my-2'>
                            <InputArea
                                control={control}
                                name="perposeofVisit"
                                label={"Perpose  Of Visit"}
                                minRows={2}
                                maxRows={3}
                            />
                        </div> */}
            <div className="my-2">
              <CommonDivider color="#000000" height={0.5} />
            </div>
            <div>
              {(passType?.label?.toLowerCase() !== "patient visitor" ||
                passType == null) && (
                <>
                  <h1 className="text-[16px] text-[#000000] font-bold mb-2">
                    Visitee Details
                  </h1>
                  <div className="grid lg:grid-cols-2 items-center gap-2">
                    <SearchDropdown
                      control={control}
                      name="whomtoMeet"
                      placeholder={"Whom to Meet*"}
                      handleInputChange={(e) => {
                        if (e !== "" && UseCheckConsecutiveCharacters(e)) {
                          getEmployeeBysearchString(e)
                            .then((response) => response.data)
                            .then((res) => {
                              setEmployeeOptions(res.result);
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        } else {
                          setEmployeeOptions([]);
                        }
                      }}
                      dataArray={employeeOptions}
                      searchIcon={true}
                      isClearable={true}
                      error={errors?.whomtoMeet}
                    />

                    {/* <InputField
                                            control={control}
                                            label="Visitee Email"
                                            name="visiteeEmail"
                                            type={"email"}
                                            error={errors?.visiteeEmail}
                                        /> */}
                    <InputField
                      control={control}
                      label="Visitee Mobile No."
                      name="visiteeMobileNo"
                      type={"number"}
                      error={errors?.visiteeMobileNo}
                    />
                    <SearchDropdown
                      control={control}
                      name="department"
                      placeholder={"Department"}
                      handleInputChange={(e) => {
                        if (e !== "" && UseCheckConsecutiveCharacters(e)) {
                          departmentDropdown(e)
                            .then((response) => response.data)
                            .then((res) => {
                              setDepartmentOptions(res.result);
                            })
                            .catch((error) => {
                              console.log(error);
                              setDepartmentOptions([]);
                            });
                        } else {
                          setDepartmentOptions([]);
                        }
                      }}
                      dataArray={departmentOptions}
                      searchIcon={true}
                      isClearable={true}
                      error={errors?.whomtoMeet}
                    />

                    <DropdownField
                      control={control}
                      placeholder="Location"
                      name="location"
                      isSearchable={true}
                      isClearable={true}
                      dataArray={locationOptions}
                      error={errors?.location}
                    />
                    <div>
                      <CheckBoxField
                        control={control}
                        name="multiVisit"
                        label={"Multi Visit"}
                      />
                    </div>
                    {isMultiVisit && (
                      <div className="grid grid-cols-2  items-center  gap-2">
                        <DatePickerField
                          name="fromdate"
                          label="From Date"
                          control={control}
                          inputFormat="dd-MM-yyyy"
                          disablePast={true}
                          maxDate={watch("toDate")}
                          slotProps={{ textField: { size: "small" } }}
                          error={errors.fromdate}
                        />
                        <DatePickerField
                          name="toDate"
                          label="To Date"
                          control={control}
                          minDate={watch("fromdate")}
                          inputFormat="dd-MM-yyyy"
                          slotProps={{ textField: { size: "small" } }}
                          error={errors.toDate}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
              {(passType == null ||
                passType?.label?.toLowerCase() !== "patient visitor") && (
                <div className="my-2 mt-3 ">
                  <CommonDivider color="#000000" height={0.5} />
                </div>
              )}
              {passType?.label?.toLowerCase() === "patient visitor" && (
                <>
                  <h1 className="text-[16px] text-[#000000] font-bold   my-2 ">
                    Patient Details
                  </h1>

                  <div className="grid lg:grid-cols-2 items-center gap-3">
                    <SearchDropdown
                      control={control}
                      name="patientNameOrUhid"
                      placeholder={" Search By Patient Name/Mobile No"}
                      handleInputChange={(e) => {
                        if (e !== "" && UseCheckConsecutiveCharacters(e)) {
                          let searchObj = {
                            currentAdmission: 0,
                            floorId: null,
                            fromDate: null,
                            isCancelled: false,
                            otherThanIndia: 0,
                            isPendingDocument: 0,
                            pendingPassport: 0,
                            presentOnBed: 1,
                            searchString: e,
                            isTentativeDischarge: false,
                            toDate: null,
                            unitId: loggedUser?.unitId,
                          };
                          getPatientBysearchString(searchObj)
                            .then((response) => response.data)
                            .then((res) => {
                              setPatientOptions(res.result);
                            })
                            .catch((error) => {
                              console.log(error);
                            });
                        } else {
                          setPatientOptions([]);
                        }
                      }}
                      dataArray={patientOptions}
                      searchIcon={true}
                      isClearable={true}
                      error={errors.patientNameOrUhid}
                    />
                    <div>
                      <CheckBoxField
                        control={control}
                        name="multiVisit"
                        label={"Multi Visit"}
                      />
                    </div>
                  </div>
                  {patientNameOrUhid && patientData !== null && (
                    <div className="text-sm rounded-md shadow-sm bg-[#F1F1F1] border border-[#000000] capitalize p-2 my-3">
                      <div className="grid grid-cols-[30%_3%_65%] lg:grid-cols-[16%_1%_40%_7%_1%_33%] gap-y-2  text-[12px] lg:text-[14px] ">
                        <div className="text-[#000000] font-medium   ">
                          {"Patient Name"}
                        </div>
                        <div className="font-semibold text-[#676767]  ">:</div>
                        <div className="break-words w-full   font-semibold text-[#676767]">
                          {patientData[0]?.["Patient Name"]}
                        </div>

                        {/* <div className="text-[#000000] font-medium  ">
                                                {"UHID"}
                                            </div>
                                            <div className='font-semibold text-[#676767] '>:</div>
                                            <div className="break-words w-full   font-semibold text-[#676767]">
                                                SP/2023/00012
                                            </div> */}
                        <div className="text-[#000000] font-medium  ">Age</div>
                        <div className="font-semibold text-[#676767]">:</div>
                        <div className="break-words w-full font-semibold text-[#676767]">
                          {patientData[0]?.["AgeYear"]}
                        </div>

                        {/* <div className="text-[#000000] font-medium  ">
                                                Contact No.
                                            </div>
                                            <div className='font-semibold text-[#676767]'>:</div>
                                            <div className="break-words  w-full  font-semibold text-[#676767]">
                                                +911234567890
                                            </div> */}

                        <div className="text-[#000000] font-medium ">
                          Department
                        </div>
                        <div className="font-semibold text-[#676767]">:</div>
                        <div className="break-words w-full  font-semibold text-[#676767]">
                          {patientData[0]?.Department}
                        </div>
                        {/* <div className="text-[#000000] font-medium ">
                                                Block
                                            </div>
                                            <div className='font-semibold text-[#676767]'>:</div>
                                            <div className="break-words  w-full  font-semibold text-[#676767]">
                                                A Block
                                            </div>
                                            <div className="text-[#000000] font-medium ">
                                                Floor
                                            </div>
                                            <div className='font-semibold text-[#676767]'>:</div>
                                            <div className="break-words w-full  font-semibold text-[#676767]">
                                                2nd Floor
                                            </div> */}
                        <div className="text-[#000000] font-medium">Ward</div>
                        <div className="font-semibold text-[#676767]">:</div>
                        <div className="break-words w-full  font-semibold text-[#676767]">
                          {patientData[0]?.Ward}
                        </div>
                        <div className="text-[#000000] font-medium">
                          Bed No.
                        </div>
                        <div className="font-semibold text-[#676767]">:</div>
                        <div className="break-words w-full  font-semibold text-[#676767]">
                          {patientData[0]?.["Bed No"]}
                        </div>
                      </div>
                    </div>
                  )}
                  {isMultiVisit && (
                    <div className="grid grid-cols-2 lg:grid-cols-4 items-center my-2  gap-3">
                      <DatePickerField
                        name="fromdate"
                        label="From Date"
                        control={control}
                        inputFormat="dd-MM-yyyy"
                        maxDate={watch("toDate")}
                        slotProps={{ textField: { size: "small" } }}
                        error={errors.fromdate}
                      />
                      <DatePickerField
                        name="toDate"
                        label="To Date"
                        control={control}
                        minDate={watch("fromdate")}
                        inputFormat="dd-MM-yyyy"
                        slotProps={{ textField: { size: "small" } }}
                        error={errors.toDate}
                      />
                    </div>
                  )}
                </>
              )}

              {(passType == null ||
                passType?.label?.toLowerCase() !== "patient visitor") && (
                <div>
                  <h1 className="text-[16px] text-[#000000] font-bold mb-2">
                    Other Details
                  </h1>

                  <div className="grid lg:grid-cols-2 items-center gap-2">
                    <div className="lg:col-span-2">
                      <InputField
                        control={control}
                        label="About Carried Luggage"
                        name="aboutCarriedLuggage"
                        type={"text"}
                      />
                    </div>
                    <DropdownField
                      control={control}
                      placeholder="Vehicle Type"
                      name="vehicleType"
                      isSearchable={true}
                      isClearable={true}
                      menuPlacement={"top"}
                      dataArray={vehicleTypeOptions}
                    />
                    <InputField
                      control={control}
                      label="Vehicle Make"
                      name="vehicleMake"
                      type={"text"}
                    />
                    <InputField
                      control={control}
                      label="Vehicle Details"
                      name="vehicleDetails"
                      type={"text"}
                      inputRef={{
                        ...register("vehicleDetails", {
                          onChange: (e) => {
                            let val = e?.target?.value?.toUpperCase();
                            setValue("vehicleDetails", val);
                          },
                        }),
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div>
            <div className="2nd border flex-col flex-wrap rounded-md p-2  h-[27rem] border-[#0000006B] shadow ">
              {/* <div className='border-b border-b-[#9F9F9F] '>
                            <h1 className='text-[16px] text-[#000000] font-bold '>Uploaded Document</h1>
                            {uploadDocuments?.length > 0 ?
                                <div className='grid grid-cols-2  just mx-8 gap-4 px-28 py-2 '>
                                    {uploadDocuments?.map((document, index, array) => {
                                        return (
                                            <div className=" w-full border rounded-md shadow-md  p-5 relative ">
                                                <img key={index} className=" w-full max-h-[100px] max-w-[150px]  rounded-md shadow-lg  object-contain "
                                                    src={document?.showImage}
                                                // src={"https://akm-img-a-in.tosshub.com/businesstoday/images/story/202304/untitled_design_90-sixteen_nine.jpg?size=1200:675"}
                                                />
                                                <div className=" absolute -right-2  -top-2" >
                                                    <button
                                                        type="button" onClick={() => {
                                                            console.log("remove click");
                                                            setUploadDocuments(array.filter((_, idx) => index !== idx))
                                                        }}>
                                                        <RemoveIcon />
                                                    </button>
                                                </div>  
                                            </div>
                                        )
                                    })}
                                </div>
                                :
                                <p className=' text-[16px] font-bold text-center my-[74px] animate-pulse '>No Document Uploaded !</p>
                            }

                        </div> */}

              <div className="">
                <h1 className="text-[16px] text-[#000000] font-bold mb-2 ">
                  Capture Using Webcam
                </h1>
                <div className="flex flex-col items-center">
                  {!showCamera && !image && (
                    <div className="flex flex-col justify-center items-center text-center">
                      {/* Camera Icon */}
                      <CameraIcon type="button" />
                      {/* Capture Photo Button */}
                      <div>
                        <CommonButton
                          type="button"
                          label="Open Camera"
                          className="border border-[#073763] text-[#073763] font-bold text-[14px] px-4 py-2"
                          onClick={() => {
                            setShowCamera(true);
                            setImage(null);
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {showCamera && (
                    <>
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/png"
                        width={320}
                        height={300}
                        screenshotQuality={1}
                        videoConstraints={videoConstraints}
                        mirrored={true}
                        onUserMedia={() => setIsCameraLoaded(true)}
                        style={{ objectFit: "cover", borderRadius: "10px" }}
                      />

                      {isCameraloaded && showCamera && (
                        <div className="my-3">
                          <CommonButton
                            type={"button"}
                            label={"Capture Photo"}
                            className={
                              "border border-[#073763] text-[#073763] font-bold text-[14px]"
                            }
                            onClick={() => {
                              capture();
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                  {image !== null && (
                    <div className="w-80 border rounded-md shadow-md p-3 relative bg-[#FFFFFF] flex justify-center items-center">
                      <div className="relative">
                        <img
                          key={image}
                          className="lg:w-80 lg:h-72 rounded-md shadow-lg"
                          src={image.showImage}
                          alt="Captured"
                        />
                        <div className="absolute -right-5 -top-4">
                          <button type="button" onClick={removeImage}>
                            <RemoveIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="flex justify-end gap-x-2 items-center my-2">
              <CommonButton
                type="button"
                label="Reset"
                className="resetButton border border-customRed text-customRed"
                onClick={() => {
                  reset(defaultValues);
                }}
              />
              <CommonButton
                type="submit"
                label={selectedRow === undefined ? "Submit" : "Update"}
                className="saveButton bg-[#4CAF50] text-white"
              />
            </div>
          </div>
        </div>
      </form>

      {postConfirmationModal && (
        <ConfirmationModal
          confirmationOpen={postConfirmationModal}
          confirmationHandleClose={() => setPostConfirmationModal(false)}
          confirmationSubmitFunc={onSubmit}
          confirmationMsg={`Are you sure you want to ${
            selectedRow === undefined ? "Add" : "Update"
          } this Record?`}
          confirmationButtonMsg={"Confirm"}
          confirmationLabel={"Confirmation"}
        />
      )}
      {isBackDrop && <CommonBackDrop openBackdrop={isBackDrop} />}
    </div>
  );
}

export default VisitorRegistration;
